import React, { useState } from "react";
import SimpleDropdown from "../../../../micro_components/SimpleDropdown";
import TextField from "@mui/material/TextField";
import CoachingPointDZ from "./CoachingPointDZ";
import BookDataService from "../../../../../services/BookService";

function ContentTab({
  target,
  bookId,
  languages,
  chosenLanguage,
  setChosenLanguage,
  links,
  setLinks,
  linkText,
  setLinkText,
  titles,
  setTitles,
  titleText,
  setTitleText,
  audioTracks,
  setAudioTracks,
  subtitles,
  setSubtitles,
  audioToUpload,
  setAudioToUpload,
  subtitlesToUpload,
  setSubtitlesToUpload,
  uploading,
  setUploading,
}) {
  const [actualAudioFile, setActualAudioFile] = useState();
  const [actualSubtitlesFile, setActualSubtitlesFile] = useState();

  const handleLanguageChange = (e) => {
    setChosenLanguage(e.target.value);
  };

  const handleUploadAudio = () => {
    setUploading({ audio: true, subtitles: false });
    BookDataService.uploadCoachingPointAudio(bookId, chosenLanguage, audioToUpload)
      .then((response) => {
        setUploading({ audio: false, subtitles: false });
        console.log("success: ", response, response.data);
        setAudioTracks({
          ...audioTracks,
          [chosenLanguage]: {
            fileNameInternal: response.data,
            metadata: {
              name: actualAudioFile.name,
              size: actualAudioFile.size,
            },
          },
        });
      })
      .catch((e) => {
        setUploading({ audio: false, subtitles: false });
        console.log("error uploading coaching point audio:", e);
      });
  };

  const handleUploadSubtitle = () => {
    setUploading({ audio: false, subtitles: true });
    BookDataService.uploadCoachingPointSubtitles(bookId, chosenLanguage, subtitlesToUpload)
      .then((response) => {
        setUploading({ audio: false, subtitles: false });
        console.log("success: ", response, response.data);
        setSubtitles({
          ...subtitles,
          [chosenLanguage]: {
            fileNameInternal: response.data,
            metadata: {
              name: actualSubtitlesFile.name,
              size: actualSubtitlesFile.size,
            },
          },
        });
      })
      .catch((e) => {
        setUploading({ audio: false, subtitles: false });
        console.log("error uploading coaching point audio:", e);
      });
  };

  const handleDeleteAsset = (type) => {
    if (type === "audio") {
      let temp = audioTracks;
      if (temp && temp[chosenLanguage]) delete temp[chosenLanguage];
      setAudioTracks(temp);
      setAudioToUpload(false);
    }
    if (type === "subtitles") {
      let temp = subtitles;
      console.log(temp);
      if (temp && temp[chosenLanguage]) delete temp[chosenLanguage];
      setSubtitles(temp);
      setSubtitlesToUpload(false);
    }
  };

  return (
    <div>
      <SimpleDropdown
        label={"Language:"}
        containerClass="language-selector-container"
        dropdownClass="language-selector"
        dropdownName="language"
        options={languages}
        onChange={handleLanguageChange}
        value={chosenLanguage}
      />
      <div className="propertiesMenu__prop">
        <TextField
          fullWidth
          value={titles[chosenLanguage] || ""}
          color="blueButton"
          variant="standard"
          label={`Title (${chosenLanguage})`}
          size="small"
          style={{ alignSelf: "flex-end" }}
          onChange={(e) => {
            setTitleText(e.target.value);
            setTitles({
              ...titles,
              [chosenLanguage]: e.target.value === "" ? undefined : e.target.value,
            });
            if (e.target.value.length === 0) delete titles[chosenLanguage];
          }}
        />
      </div>
      <div className="propertiesMenu__prop" style={{ marginTop: "0.5em" }}>
        <TextField
          fullWidth
          value={links[chosenLanguage] || ""}
          color="blueButton"
          variant="standard"
          label={`Link to media (${chosenLanguage})`}
          size="small"
          style={{ alignSelf: "flex-end" }}
          onChange={(e) => {
            setLinkText(e.target.value);
            setLinks({
              ...links,
              [chosenLanguage]: e.target.value === "" ? undefined : e.target.value,
            });
          }}
        />
      </div>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "1em 0.5em 0.5em 0.5em",
            boxSizing: "border-box",
          }}
        >
          <CoachingPointDZ
            type="audio"
            chosenLanguage={chosenLanguage}
            point={target}
            prepareFile={setAudioToUpload}
            fileReady={Boolean(audioToUpload)}
            uploadFunc={handleUploadAudio}
            uploading={uploading}
            setUploading={setUploading}
            existing={audioTracks && audioTracks[chosenLanguage]}
            updateFileName={setActualAudioFile}
            audioTracks={audioTracks}
            setAudioTracks={setAudioTracks}
            subtitles={subtitles}
            setSubtitles={setSubtitles}
            handleDelete={handleDeleteAsset}
          />
          <CoachingPointDZ
            type="subtitles"
            chosenLanguage={chosenLanguage}
            point={target}
            prepareFile={setSubtitlesToUpload}
            fileReady={Boolean(subtitlesToUpload)}
            uploadFunc={handleUploadSubtitle}
            uploading={uploading}
            existing={subtitles && subtitles[chosenLanguage]}
            updateFileName={setActualSubtitlesFile}
            audioTracks={audioTracks}
            setAudioTracks={setAudioTracks}
            subtitles={subtitles}
            setSubtitles={setSubtitles}
            handleDelete={handleDeleteAsset}
          />
        </div>
      </div>
    </div>
  );
}

export default ContentTab;
